module.exports = __webpack_public_path__ + "img/1.38b55bbd.png";